export enum WorkspaceSubscriptionProblemKey {
  Overdue = "overdue",
  Lapsed = "lapsed",
}

export type WorkspaceSubscriptionProblem = {
  key: WorkspaceSubscriptionProblemKey;
  bannerMessage: string;
  subscriptionStatusLabel: string;
  infoTitle: string;
  infoResolutionMessage: string;
  actionLabel: string;
};
